import axios from "axios";
import Vue from "vue";
import { mapActions } from "vuex";
import { PRICE_TYPES } from "../constants/custom-define-type";
import { MAP_DIALOG_SECTION } from "../constants/field-types";

Vue.mixin({
    methods: {
        ...mapActions(["getUserDeviceId"]),
        calculateHoursWorked(job, savedModel = null) {
            if (savedModel && job[savedModel]) {
                return job[savedModel];
            }
            if (job.actual_start_time && job.actual_end_time) {
                let result = this.calculateDuration(
                    job.actual_start_date,
                    job.actual_start_time,
                    job.actual_end_date,
                    job.actual_end_time,
                    job.breaks
                );
                // Hours worked of shift jobs cannot be greater than or equal to 24 hours
                // The result may incorrect because of incorrect actual_end_date
                if (result > 24) {
                    // Overnight booking
                    if (job.end_date && job.end_date >= job.actual_end_date) {
                        return result;
                    }
                    result = result - Math.floor(result / 24) * 24;
                }
                return result;
            }
            return null;
        },
        getJobCategory(job, categoryList) {
            if (job.category) {
                return job.category;
            }
            // If there is only one category, set it as job category
            if (
                categoryList &&
                categoryList.length === 1
            ) {
                return categoryList[0];
            }
            return "";
        },
        isCategoryEqual(job, price, categoryList) {
            const jobCategory = this.getJobCategory(job, categoryList);
            const jobCategoryPrices = price.job_categories;
            // Job category empty or undefined
            if (jobCategoryPrices == null || jobCategoryPrices.length === 0) {
                return true;
            }
            for (const jobCategoryPrice of jobCategoryPrices) {
                if (this.compareTextWithoutPunctuation(jobCategory, jobCategoryPrice)) {
                    return true;
                }
            }
            return false;
        },
        isZipCodeEqual(job, price) {
            const zipCodePrices = price.zip_codes;
            // Zip Code Prices is empty or undefined
            if (zipCodePrices == null || zipCodePrices.length === 0) {
                return true;
            }
            for (const zipCodePrice of zipCodePrices) {
                if (this.compareTextWithoutPunctuation(job.postal_code, zipCodePrice)) {
                    return true;
                }
            }
            return false;
        },
        isJobMatchPrice(job, price, categoryList) {
            // Compare category
            if (!this.isCategoryEqual(job, price, categoryList)) {
                return false;
            }
            // Compare Zip Code
            if (!this.isZipCodeEqual(job, price)) {
                return false;
            }
            // Compare out of town
            if (price.is_out_of_town) {
                if (job.is_out_of_town === false) {
                    return false;
                }
            }
            if (price.is_out_of_town === false) {
                if (job.is_out_of_town) {
                    return false;
                }
            }
            // Compare restricted date
            if (price.is_restrict_date && price.restrict_dates) {
                let bookingDay = this.dateInDjangoFormat(job.date || this.selectedDate);
                // Remove year
                bookingDay = bookingDay.substring(4);
                if (!price.restrict_dates.some(date => date.includes(bookingDay))) {
                    return false;
                }
            }
            // Price is used for job if it is created before job
            let compareDate = job.created_date;
            // If the price is created before the job's last update
            if (job.last_updated_date) {
                compareDate = job.last_updated_date;
            }
            if (compareDate && price.created_date) {
                return price.created_date <= compareDate;
            }
            return true;
        },
        getAdminFee(totalFee, job) {
            if (!job) {
                return 0;
            }
            if (job.admin_fee) {
                if (job.admin_fee === "0.00") {
                    return 0;
                }
                return job.admin_fee;
            }
            const priceItem = this.$store.getters.priceList.find(
                (price) =>
                    price.type === PRICE_TYPES.ADMIN_FEE &&
                    this.isJobMatchPrice(job, price)
            );
            if (!priceItem) {
                return 0;
            }
            return (Number(totalFee) * Number(priceItem.percentage)) / 100;
        },
        formatJobDate(job) {
            if (!job.date) {
                return '';
            }
            return this.addTimeToDate(job.date).toDateString();
        },
        calculateSuggestedHours(job, filler) {
            console.log(filler);
            const listActualModels = ['actual_start_date', 'actual_start_time', 'actual_end_date', 'actual_end_time', 'breaks'];
            const jobInfo = { ...job };
            if (filler && filler.info) {
                listActualModels.forEach(model => {
                    if (filler.info[model]) {
                        jobInfo[model] = filler.info[model];
                    }
                })
            }
            return this.calculateHoursWorked(jobInfo) || this.calculateHoursBooked(jobInfo);
        },
        calculateSuggestedClientCharge(job, listJobFillers) {
            let filler = null;
            if (listJobFillers && listJobFillers.length) {
                filler = listJobFillers[0];
            }
            //load values into variables to avoid null errors
            let total = 0;
            let hours = job.hours_worked ? parseFloat(job.hours_worked) : 0;
            if (!hours) {
                hours = this.calculateSuggestedHours(job, filler) || 0
            }
            let clientRate = job.client_rate
                ? parseFloat(job.client_rate)
                : 0;
            let candidateRate = job.candidate_rate
                ? parseFloat(job.candidate_rate)
                : 0;
            let agencyRate = job.agency_fee
                ? parseFloat(job.agency_fee)
                : 0;
            let travelFee = job.travel_fee ? parseFloat(job.travel_fee) : 0;
            let rushFee = job.rush_fee ? parseFloat(job.rush_fee) : 0;
            let perBookingAgencyFee = job.per_booking_agency_fee
                ? parseFloat(job.per_booking_agency_fee)
                : 0;
            let perBookingCandidateFee = job.per_booking_candidate_fee
                ? parseFloat(job.per_booking_candidate_fee)
                : 0;
            let additionalFee = job.additional_fee
                ? parseFloat(job.additional_fee)
                : 0;
            let tip = job.tip ? parseFloat(job.tip) : 0
            if (clientRate) {
                total += clientRate * hours;
            } else {
                total += candidateRate * hours;
                total += agencyRate * hours;
            }
            total +=
                perBookingCandidateFee +
                travelFee +
                perBookingAgencyFee +
                rushFee +
                additionalFee +
                tip;
            const adminFee = this.getAdminFee(total, job);
            total += Number(adminFee);
            return total.toFixed(2);
        },
        calculateHoursBooked(job) {
            const result = this.calculateDuration(
                job.date,
                job.start_time,
                job.end_date,
                job.end_time
            );
            if (result) {
                return this.roundNumberTwoDigits(result);
            }
            return null;
        },
        calculateRegularHoursWorked(job) {
            const hoursWorked = this.calculateHoursWorked(job);
            if (!hoursWorked) {
                return null;
            }
            const result = hoursWorked > 8 ? 8 : hoursWorked
            return result.toFixed(2);
        },
        calculateOvertimeHoursWorked(job) {
            const hoursWorked = this.calculateHoursWorked(job);
            if (!hoursWorked) {
                return null;
            }
            const result = hoursWorked > 8 ? hoursWorked - 8 : 0
            return result.toFixed(2);
        },
        calculateHoursWorkedFormatted(job) {
            const hoursWorked = this.calculateHoursWorked(job, 'hours_worked');
            if (!hoursWorked) {
                return null;
            }
            if (typeof hoursWorked == 'string') {
                return hoursWorked;
            }
            return hoursWorked.toFixed(2);
        },
        calculateCandidatePay(job, filler) {
            let booking_fee = job.per_booking_candidate_fee
                ? job.per_booking_candidate_fee
                : 0;
            let tip = job && job.tip ? Number(job.tip) : 0;
            let candidate_pay;
            if (filler && filler.info) {
                if (job.actual_start_time && !filler.info.actual_start_time) {
                    filler.info.actual_start_time = job.actual_start_time;
                }
                if (job.actual_start_date && !filler.info.actual_start_date) {
                    filler.info.actual_start_date = job.actual_start_date;
                }
                candidate_pay =
                    job.candidate_rate * this.calculateHoursWorked(filler.info) +
                    parseFloat(booking_fee) +
                    tip;
            } else {
                candidate_pay =
                    job.candidate_rate * this.calculateHoursWorked(job) +
                    parseInt(booking_fee) +
                    tip;
            }
            if (!candidate_pay) {
                return null;
            }
            return this.roundNumberTwoDigits(candidate_pay);
        },
        // Calculate both agency fee and candidate fee
        calculateJobCharge(job, filler, passedHoursWorked = null, excludeTip = false) {
            let hoursWorked = 0;
            if (passedHoursWorked) {
                hoursWorked = passedHoursWorked;
            } else {
                if (filler && filler.info) {
                    if (job.actual_start_time && !filler.info.actual_start_time) {
                        filler.info.actual_start_time = job.actual_start_time;
                    }
                    if (job.actual_start_date && !filler.info.actual_start_date) {
                        filler.info.actual_start_date = job.actual_start_date;
                    }
                    hoursWorked = this.calculateHoursWorked(filler.info)

                } else {
                    hoursWorked = this.calculateHoursWorked(job)
                }
            }
            let agencyAmount = 0;
            let candidateAmount = 0;
            let hasAgencyFee = false;
            if (job.agency_fee && !isNaN(job.agency_fee)) {
                hasAgencyFee = true;
                agencyAmount = Number(job.agency_fee) * hoursWorked;
            }
            if (job.client_rate && !isNaN(job.client_rate)) {
                candidateAmount = Number(job.client_rate) * hoursWorked;
                if (job.candidate_rate && !isNaN(job.candidate_rate)) {
                    candidateAmount = Number(job.candidate_rate) * hoursWorked;
                    if (!hasAgencyFee) {
                        agencyAmount =
                            (Number(job.client_rate) - Number(job.candidate_rate)) *
                            hoursWorked;
                    }
                }
            }

            if (!candidateAmount) {
                if (this.$store.getters.adminCanSetCandidateRate) {
                    if (filler && filler.rate && !isNaN(filler.rate)) {
                        candidateAmount = Number(filler.rate) * hoursWorked;
                    }
                }
            }

            if (filler && filler.info) {
                if (this.$store.getters.chargeTransferIncludeMileage) {
                    const numberOfMiles = filler.info.mileage;
                    if (numberOfMiles) {
                        candidateAmount += Number(numberOfMiles) * this.$store.getters.chargeTransferPricePerMile
                    }
                }
                if (this.$store.getters.chargeTransferIncludeReimbersement) {
                    const reimbursement = filler.info.reimbursement;
                    if (reimbursement) {
                        candidateAmount += Number(reimbursement);
                    }
                }
            }

            const listFeeModelAgency = [
                "rush_fee",
                "per_booking_agency_fee",
                "admin_fee",
                "admin_fee_subtraction",
                "additional_fee",
            ];
            const listFeeModelCandidate = [
                "travel_fee",
                "candidate_rush_fee",
                "per_booking_candidate_fee"
            ];
            if (!excludeTip) {
                listFeeModelCandidate.push("tip");
            }
            for (const feeModel of listFeeModelAgency) {
                if (job[feeModel] && !isNaN(job[feeModel])) {
                    agencyAmount += Number(job[feeModel]);
                }
            }
            for (const feeModel of listFeeModelCandidate) {
                if (job[feeModel] && !isNaN(job[feeModel])) {
                    candidateAmount += Number(job[feeModel]);
                }
            }
            if (job.admin_fee_subtraction && !isNaN(job.admin_fee_subtraction)) {
                candidateAmount = candidateAmount - Number(job.admin_fee_subtraction);
            }
            return {
                candidateAmount: this.roundNumberTwoDigits(candidateAmount),
                agencyAmount: this.roundNumberTwoDigits(agencyAmount)
            }
        },
        getListDateTimeOfJobs(job) {
            if (!job.date) {
                return [];
            }
            // Repeat booking or multiple bookings
            const listStartDateTimes = this.getListDateOfRepeatBooking(job, null);
            // Get list dates from start_date to end_date of the booking
            const jobStartDate = this.dateInDjangoFormat(job.date);
            const startTimeString = this.getTimeString(job.start_time);
            let endTimeString = this.getTimeString(job.end_time);
            let endingByMidnight = false;
            if (endTimeString === "00:00:00") {
                endingByMidnight = true;
                endTimeString = "23:59:59";
            }
            if (job.end_date && this.dateInDjangoFormat(job.end_date) > jobStartDate) {
                const listDates = this.getDatesInRange(jobStartDate, job.end_date);
                if (endingByMidnight) {
                    listDates.pop();
                }
                const result = [];
                listStartDateTimes.forEach((dateTimes, bookingIndex) => {
                    const date = dateTimes.date;
                    for (let index = 0; index < listDates.length; index++) {
                        const dateObj = new Date(date + 'T12:00:00');
                        // Find start and end in hours of job
                        let startTime;
                        let endTime;
                        if (index === 0) {
                            startTime = this.getTimeString(dateTimes.start_time);
                        } else {
                            startTime = "00:00:00";
                        }
                        if (index === listDates.length - 1) {
                            endTime = this.getTimeString(dateTimes.end_time);
                        } else {
                            endTime = "23:59:59";
                        }
                        if (!endTime || endTime === "00:00:00") {
                            endTime = "23:59:59";
                        }
                        result.push({
                            date: this.dateInDjangoFormat(this.addDaysToDate(index, dateObj)),
                            startTime: startTime,
                            endTime: endTime,
                            index: bookingIndex
                        });
                    }
                });
                console.log(result);
                return result;
            } else {
                // Not overnight booking
                if (!startTimeString || !endTimeString || (startTimeString < endTimeString)) {
                    return listStartDateTimes.map((dateTimes, index) => {
                        let endTimeString = this.getTimeString(dateTimes.end_time);
                        if (endTimeString === "00:00:00") {
                            endTimeString = "23:59:59";
                        }
                        return {
                            date: dateTimes.date,
                            startTime: this.getTimeString(dateTimes.start_time) || "00:00:00",
                            endTime: endTimeString || "23:59:59",
                            index: index
                        }
                    })
                }
                // Overnight booking
                let result = [];
                listStartDateTimes.forEach((dateTimes, index) => {
                    let endTimeString = this.getTimeString(dateTimes.end_time);
                    if (endTimeString === "00:00:00") {
                        endTimeString = "23:59:59";
                    }
                    result.push({
                        date: dateTimes.date,
                        startTime: this.getTimeString(dateTimes.start_time) || "00:00:00",
                        endTime: "23:59:59",
                        index: index // Index to track for the same booking
                    });
                    result.push({
                        date: this.getNextDate(dateTimes.date),
                        startTime: "00:00:00",
                        endTime: endTimeString,
                        index: index
                    })
                })
                return result;
            }
        },
        isTimeOffConflict(candidate, listRelatedAvailabilities, listDateTimesOfJobs) {
            const listCandidateTimeOff = listRelatedAvailabilities.filter(
                (availability) =>
                    availability.user === candidate.id &&
                    availability.type === "Time Off" &&
                    availability.status !== "Declined"
            );
            for (const dateTimes of listDateTimesOfJobs) {
                if (
                    listCandidateTimeOff.some(
                        (timeOff) =>
                            timeOff.date === dateTimes.date &&
                            (timeOff.unavailable ||
                                this.isTimeRangeOverlap(
                                    timeOff.start_time,
                                    timeOff.end_time,
                                    dateTimes.startTime,
                                    dateTimes.endTime
                                ))
                    )
                ) {
                    return true;
                }
            }
            return false;
        },
        filterJobsOfCandidate(jobs, candidateId) {
            const result = jobs.filter(job => !this.$store.getters.listShiftJobStatusesCancelled.includes(job.status));
            if (this.$store.getters.multipleFillersShiftJob) {
                return this.filterJobsOfCandidateMultiFiller(result, candidateId);
            } else {
                return this.filterJobsOfCandidateOneFiller(result, candidateId);
            }
        },
        filterJobsOfCandidateMultiFiller(jobs, candidateId) {
            return jobs.filter(
                (job) => {
                    if (Array.isArray(job.fillers)) {
                        if (!job.fillers || !job.fillers.length) {
                            return false;
                        }
                        for (const filler of job.fillers) {
                            if (filler === candidateId) {
                                return true;
                            }
                            if (typeof filler === 'object') {
                                if (filler.id === candidateId) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    } else {
                        return job.fillers === candidateId;
                    }
                }
            );
        },
        filterJobsOfCandidateOneFiller(jobs, candidateId) {
            return jobs.filter(job => Number(job.filler) === candidateId);
        },
        isExceedMaxJobDaily(candidate, jobs, targetJob, listDateTimesOfJobs) {
            if (this.$store.getters.hideMaximumBookingsUserCanHaveCandidateProfile) {
                return false;
            }
            const maxNumber = candidate.max_booking_number_daily;
            if (!maxNumber) {
                return false;
            }
            let listCandidateJobs = this.filterJobsOfCandidate(jobs, candidate.id);
            if (targetJob && targetJob.id) {
                listCandidateJobs = listCandidateJobs.filter(job => job.id !== targetJob.id);
            }
            const listDates = listDateTimesOfJobs.map(dateTime => this.dateInDjangoFormat(dateTime.date));
            for (const date of listDates) {
                const numberJobs = listCandidateJobs.filter(job => job.date === date).length;
                if (numberJobs >= maxNumber) {
                    return true;
                }
            }
            return false;
        },
        isTimeConflict(candidate, jobs, targetJob) {
            if (!jobs) {
                return null;
            }
            const listCandidateJobs = this.filterJobsOfCandidate(jobs, candidate.id);
            let bufferHours = Number(candidate.buffer_time) || this.$store.getters.defaultCandidateBufferTime;
            if (bufferHours) {
                // For example: if bufferHours = 1h, first job ending by 10:00, the second can start from 11:00
                // We need to reduce bufferHours a little bit to handle that case
                bufferHours = bufferHours - 0.001;
            }
            let listDateTimesOfJobs = []; // List date time of job + buffer time
            const listStartDateTimes = this.getListDateOfRepeatBooking(targetJob, null);
            for (const startDateTimes of listStartDateTimes) {
                const startDate = startDateTimes.date;
                const startTime = this.getTimeString(startDateTimes.start_time);
                const endTime = this.getTimeString(startDateTimes.end_time);
                const jobTimeWithBuffer = this.subtractDateByHour(this.dateInDjangoFormat(startDate),
                    startTime, bufferHours);
                const endDate = this.getBookingEndDate({
                    ...targetJob,
                    date: startDate,
                    start_time: startTime,
                    end_time: endTime
                })
                const jobEndTimeWithBuffer = this.addDateByHour(this.dateInDjangoFormat(endDate),
                    endTime, bufferHours);
                const bufferTimeJob = {
                    date: jobTimeWithBuffer.date,
                    start_time: jobTimeWithBuffer.time,
                    end_date: jobEndTimeWithBuffer.date,
                    end_time: jobEndTimeWithBuffer.time
                }
                listDateTimesOfJobs = [...listDateTimesOfJobs, ...this.getListDateTimeOfJobs(bufferTimeJob)];
            }
            for (const job of listCandidateJobs) {
                if (targetJob.id) {
                    if (job.id === targetJob.id) {
                        continue;
                    }
                }
                // Check conflict of each job with the current job
                const listDateTimeOfJobs2 = this.getListDateTimeOfJobs(job);
                for (const datetimes2 of listDateTimeOfJobs2) {
                    for (const datetimes of listDateTimesOfJobs) {
                        if (datetimes.date !== datetimes2.date) {
                            continue;
                        }
                        if (
                            this.isTimeRangeOverlap(
                                datetimes.startTime,
                                datetimes.endTime,
                                datetimes2.startTime,
                                datetimes2.endTime
                            )
                        ) {
                            return job;
                        }
                    }
                }
            }

            return null;
        },
        isAvailabilityConflict(candidate, listRelatedAvailabilities, weekAvailabilities, listDateTimesOfJobs, acceptNoAvailability = false) {
            // We want to get the availabilities belonging to each candidate
            let candidateAvailabilities = listRelatedAvailabilities.filter(
                (availability) => {
                    return (
                        availability.user == candidate.id &&
                        availability.type == "Availability"
                    );
                }
            );

            // Check if user is unavailable in one of list dates
            const isUnavaialble = candidateAvailabilities.some(
                (availability) => availability.unavailable
            );
            if (isUnavaialble) {
                // Unavailable in one of the dates
                return true;
            }

            const listWeekAvailabilities = weekAvailabilities
                .filter((weekAvailability) => {
                    return weekAvailability.user == candidate.id;
                })
                .sort((a, b) => (a.effective_date < b.effective_date ? 1 : -1));

            for (const datetimes of listDateTimesOfJobs) {
                const date = datetimes.date;
                let listDayBlocksAvailability = candidateAvailabilities
                    .filter(
                        (availability) =>
                            availability.date === date && !availability.unavailable
                    )
                    .map((availability) => {
                        let endTime = availability.end_time;
                        if (availability.start_time && endTime && endTime < availability.start_time) {
                            // Next day
                            endTime = "23:59:59";
                        }
                        return [
                            availability.start_time,
                            endTime,
                        ]
                    });
                if (!listDayBlocksAvailability.length) {
                    // If there is no day availabilities, weekly availability will be used
                    const currentWeekAvailability = listWeekAvailabilities.find(
                        (weekAvailability) =>
                            this.isEffectiveObject(weekAvailability, date)
                    );
                    if (currentWeekAvailability) {
                        listDayBlocksAvailability =
                            currentWeekAvailability[this.getDayOfWeek(date)];
                    }
                }
                // Find start and end in hours of job
                const startInHours = this.convertTimeToInHours(datetimes.startTime);
                const endInHours = this.convertTimeToInHours(datetimes.endTime);
                // Find an availability which contains duration from startTime to endTime
                const hasAvailability = listDayBlocksAvailability.some(
                    (availability) => {
                        if (!availability[0]) {
                            return false;
                        }
                        const availabilityStart = this.convertTimeToInHours(
                            availability[0]
                        );
                        let availabilityEndTime = availability[1];
                        if (!availabilityEndTime || availabilityEndTime === "00:00:00") {
                            availabilityEndTime = "23:59:59";
                        }
                        const availabilityEnd =
                            this.convertTimeToInHours(availabilityEndTime);

                        // If the job times fall within the availability block, we are good to go

                        return (
                            startInHours >= availabilityStart && endInHours <= availabilityEnd
                        );
                    }
                );
                if (!hasAvailability) {
                    if (!acceptNoAvailability) {
                        return true;
                    }
                }
            }
            return false;
        },
        hasNoAvailability(candidate, listRelatedAvailabilities, weekAvailabilities, listDateTimesOfJobs) {
            // We want to get the availabilities belonging to each candidate
            let candidateAvailabilities = listRelatedAvailabilities.filter(
                (availability) => {
                    return (
                        availability.user == candidate.id &&
                        availability.type == "Availability"
                    );
                }
            );
            const listWeekAvailabilities = weekAvailabilities
                .filter((weekAvailability) => {
                    return weekAvailability.user == candidate.id;
                })
                .sort((a, b) => (a.effective_date < b.effective_date ? 1 : -1));


            for (const datetimes of listDateTimesOfJobs) {
                const date = datetimes.date;
                let listDayBlocksAvailability = candidateAvailabilities
                    .filter(
                        (availability) =>
                            availability.date === date && !availability.unavailable
                    );
                if (listDayBlocksAvailability.length) {
                    return false;
                }
                // If there is no day availabilities, weekly availability will be used
                const currentWeekAvailability = listWeekAvailabilities.find(
                    (weekAvailability) =>
                        this.isEffectiveObject(weekAvailability, date)
                );
                if (currentWeekAvailability) {
                    listDayBlocksAvailability =
                        currentWeekAvailability[this.getDayOfWeek(date)];
                    if (listDayBlocksAvailability && listDayBlocksAvailability.length) {
                        return false;
                    }
                }
            }
            return true;
        },
        /* Get map of all candidate which is available on 'date'
         Return:
         candidateID => [{start: startTime, end: endTime}]
         */
        getMapAvailableCandidates(date, listAvailabilities, listWeekAvailabilities, listJobs, listFilteredIds, listCandidates) {
            if (!date) {
                return {};
            }
            // Get all candidates which has availabilities on 'date'
            const dayOfWeek = this.getDayOfWeek(date);
            const listRelatedDayAvailabilities = listAvailabilities.filter(availability => availability.date === date);
            const listRelatedWeekAvailabilities = listWeekAvailabilities.filter(weekAvailability => {
                const availabilityOfDay = weekAvailability[dayOfWeek];
                if (!availabilityOfDay || !availabilityOfDay.length) {
                    return false;
                }
                if (!this.isEffectiveObject(weekAvailability, date)) {
                    return false;
                }
                return true;
            }).sort((a, b) => (a.effective_date < b.effective_date ? 1 : -1));
            let listCandidateIds = [...listRelatedDayAvailabilities.map(availability => availability.user), ...listRelatedWeekAvailabilities.map(availability => availability.user)];
            if (listFilteredIds) {
                listCandidateIds = listCandidateIds.filter(id => listFilteredIds.includes(id));
            }
            listCandidateIds = this.deduplicateArrayOfObject(listCandidateIds);
            const result = {};
            const minDuration = this.$store.getters.shiftRequestMinimumHoursAllTypes;
            // Check availability duration of each candidate in the list
            for (const candidateId of listCandidateIds) {
                // Find list available time blocks of the candidate
                let listAvailableBlocks = [];
                const listUnavailableBlocks = []; // Time off or has job
                const listCandidateDayAvailability = listRelatedDayAvailabilities.filter(availability => availability.user === candidateId);
                let isUnavaialble = false;
                for (const dayAvailability of listCandidateDayAvailability) {
                    if (dayAvailability.type === 'Availability') {
                        if (dayAvailability.unavailable) {
                            // All day unavailable
                            isUnavaialble = true;
                            break;
                        }
                        const availabilityBlock = this.getTimeBlock(dayAvailability);
                        const duration = this.calculateDiffTimeInHours(availabilityBlock.startTime, availabilityBlock.endTime);
                        if (duration < minDuration) {
                            continue;
                        }
                        listAvailableBlocks.push(availabilityBlock);
                    } else if (dayAvailability.type === "Time Off" &&
                        dayAvailability.status !== "Declined") {
                        if (dayAvailability.unavailable) {
                            // Check if all day timeoff
                            isUnavaialble = true;
                            break;
                        }
                        listUnavailableBlocks.push(this.getTimeBlock(dayAvailability));
                    }
                }
                if (isUnavaialble) {
                    continue;
                }
                // If day availability is not defined => check week availability
                if (!listAvailableBlocks.length) {
                    const currentWeekAvailability = listRelatedWeekAvailabilities.find(
                        (availability) =>
                            availability.user === candidateId
                    );
                    if (currentWeekAvailability) {
                        const listBlocks = currentWeekAvailability[dayOfWeek];
                        if (listBlocks && listBlocks.length) {
                            for (const block of listBlocks) {
                                const availabilityBlock = {
                                    startTime: block[0] || '00:00:00',
                                    endTime: block[1] || '23:59:59'
                                }
                                if (availabilityBlock.endTime === '00:00:00') {
                                    availabilityBlock.endTime = '23:59:59';
                                }
                                listAvailableBlocks.push(availabilityBlock);
                            }
                        }
                    }
                }
                // Find list jobs of candidate
                const listCandidateJobs = this.filterJobsOfCandidate(listJobs.filter(job => job.date === date), candidateId);
                let bufferHours = this.$store.getters.defaultCandidateBufferTime;
                const candidate = listCandidates.find(candidate => candidate.id === candidateId);
                if (candidate) {
                    bufferHours = Number(candidate.buffer_time) || this.$store.getters.defaultCandidateBufferTime;
                }
                for (const job of listCandidateJobs) {
                    listUnavailableBlocks.push(this.getTimeBlock(job, bufferHours));
                }
                // Check for all block in list available, but not in list unavailable
                if (listAvailableBlocks.length) {
                    if (listUnavailableBlocks.length) {
                        let listTimePoint = [];
                        for (const block of [...listAvailableBlocks, ...listUnavailableBlocks]) {
                            listTimePoint.push(block.startTime);
                            listTimePoint.push(block.endTime);
                        }
                        listTimePoint = this.deduplicateArrayOfObject(listTimePoint).sort();
                        const listBlocks = [];
                        for (let index = 0; index < listTimePoint.length - 1; index++) {
                            const startTime = listTimePoint[index];
                            const endTime = listTimePoint[index + 1];
                            // Check if block [startTime, endTime] in any unavailable block
                            if (listUnavailableBlocks.some(block => block.startTime <= startTime && block.endTime >= endTime)) {
                                continue;
                            }
                            if (listAvailableBlocks.some(block => block.startTime <= startTime && block.endTime >= endTime)) {
                                const duration = this.calculateDiffTimeInHours(startTime, endTime);
                                if (duration < minDuration) {
                                    continue;
                                }
                                listBlocks.push({ startTime: startTime, endTime: endTime });
                            }
                        }
                        listAvailableBlocks = listBlocks;
                    }
                }
                if (listAvailableBlocks.length) {
                    result[candidateId] = listAvailableBlocks;
                }
            }
            return result;
        },
        // Get startTime, endTime from object
        getTimeBlock(obj, bufferHours) {
            let startTime = obj.start_time || '00:00:00';
            let endTime = obj.end_time || '23:59:59';
            if (endTime === '00:00:00') {
                endTime = '23:59:59'
            }
            if (obj.end_date && obj.end_date > obj.date) { // Overnight booking
                endTime = '23:59:59'
            }

            if (bufferHours) {
                const newStartTime = this.subtractDateByHour(this.todayDjangoFormat, startTime, bufferHours);
                if (newStartTime.date != this.todayDjangoFormat) {
                    // Previous day
                    startTime = '00:00:00';
                } else {
                    startTime = newStartTime.time;
                }
                const newEndTime = this.addDateByHour(this.todayDjangoFormat, endTime, bufferHours);
                if (newEndTime.date != this.todayDjangoFormat) {
                    // Next day
                    endTime = '23:59:59'
                } else {
                    endTime = newEndTime.time;
                }
            }
            return {
                startTime: startTime,
                endTime: endTime
            }
        },
        getListDateOfRepeatBooking(job, selectedDate) {
            if (!job) {
                return [];
            }
            let startDate = job.date || selectedDate;
            if (!startDate) {
                return [];
            }
            let listAdditionalDates = job.additional_dates || [];
            listAdditionalDates = listAdditionalDates.filter(date => date.date);
            startDate = this.dateInDjangoFormat(startDate);
            const startTime = this.getTimeString(job.start_time);
            const endTime = this.getTimeString(job.end_time);
            const baseBooking = {
                date: startDate,
                start_time: startTime,
                end_time: endTime
            }
            if (!job.repeat || !job.repeat_end_date || !job.repeat_count || !job.repeat_type) {
                return [baseBooking, ...listAdditionalDates];
            }
            const result = [];
            if (job.repeat_type == 'Days') {
                let date = startDate;
                const endDate = this.dateInDjangoFormat(job.repeat_end_date);
                while (date <= endDate) {
                    result.push(date);
                    date = this.getDateAfterDays(date, job.repeat_count)
                }
            } else {
                let repeatWeekDay = job.repeat_weekdays;
                if (!repeatWeekDay || !repeatWeekDay.length) {
                    return [baseBooking, ...listAdditionalDates];
                }
                repeatWeekDay = repeatWeekDay.map(day => day.toLowerCase());
                let date = startDate;
                let count = 0;
                const endDate = this.dateInDjangoFormat(job.repeat_end_date);
                while (date <= endDate) {
                    count += 1
                    if (count <= 7) {
                        console.log(repeatWeekDay)
                        if (repeatWeekDay.includes(this.getDayOfWeek(date))) {
                            result.push(date);
                        }
                        date = this.getDateAfterDays(date, 1)
                    } else {
                        count = 0
                        date = this.getDateAfterDays(date, (7 * (job.repeat_count - 1)));
                    }
                }
            }
            const listRecurringBookings = this.deduplicateArrayOfObject([...result.map(date => ({
                date: date,
                start_time: startTime,
                end_time: endTime
            }))], 'date');
            return [...listRecurringBookings, ...listAdditionalDates];

        },
        // calculate how many hours a candidate is working this week
        getWeeklyHours(candidate, filteredJobs, startDate, endDate) {
            let result = 0;
            let candidateJobs = filteredJobs.filter((job) => {
                if (this.$store.getters.listShiftJobStatusesCancelled.includes(job.status)) {
                    return false;
                }
                if (this.$store.getters.multipleFillersShiftJob) {
                    if (!job.fillers || !job.fillers.includes(candidate.id)) {
                        return false;
                    }
                } else {
                    if (job.filler != candidate.id) {
                        return false;
                    }
                }
                return (
                    job.date >= startDate &&
                    job.date <= endDate
                );
            });
            for (const job of candidateJobs) {
                if (!job.start_time || !job.end_time) {
                    continue;
                }
                const jobDuration = this.calculateDuration(
                    job.date,
                    job.start_time,
                    job.end_date,
                    job.end_time,
                    job.breaks
                );
                result += jobDuration;
            }
            return this.roundNumberTwoDigits(result);
        },
        correctEndDate(booking) {
            if (!booking.date) {
                return;
            }
            booking.end_date = this.getBookingEndDate(booking);
        },
        getBookingEndDate(booking) {
            if (!booking.date) {
                return;
            }
            if (booking.end_date) {
                if (booking.date < booking.end_date) {
                    return booking.end_date;
                }
            }
            if (booking.start_time && booking.end_time) {
                if (booking.start_time >= booking.end_time) {
                    // End date = Start date + 1
                    return this.getNextDate(booking.date);
                }
            }
            return booking.date;
        },
        getPosterName(job) {
            let posterName;
            if (this.$store.getters.shiftJobCalendarClientNameModel === "name") {
                posterName = `${job.poster__first_name} ${job.poster__last_name}`;
            } else {
                posterName = job["poster__" + this.$store.getters.shiftJobCalendarClientNameModel];
            }
            return posterName;
        },
        isJobCreatedInBusinessHour(job) {
            const businessHours = this.$store.getters.businessHours;
            if (businessHours && businessHours.length) {
                const createdDate = job && job.created_date ? new Date(job.created_date) : new Date();
                let dayNum = createdDate.getDay()
                // They start the days of the week from Sunday (as 0)
                dayNum = dayNum - 1 // Want to turn Monday into 0
                if (dayNum === -1) {
                    dayNum = 6 // Need Sunday to be 6
                }
                const hoursRangeStr = businessHours[dayNum];
                if (hoursRangeStr) {
                    const hourRange = hoursRangeStr.split('\t');
                    const startTime = hourRange[0];
                    const endTime = hourRange[1];
                    const createdTime = this.getTimeStringFromDateTime(createdDate);
                    const startTimeStr = this.getTimeString(startTime);
                    const endTimeStr = this.getTimeString(endTime);
                    if (startTime && createdTime < startTimeStr) {
                        return { isInside: false, startTime: startTimeStr, endTime: endTimeStr };
                    }
                    if (endTime && createdTime > endTimeStr) {
                        return { isInside: false, startTime: startTimeStr, endTime: endTimeStr };
                    }
                    return { isInside: true };
                } else {
                    return { isInside: false };
                }
            } else {
                // Business hours is not defined
                return { isInside: true };
            }
        },
        filterJobsByMinChildrenAge(listJobs, user) {
            if (!user) {
                return listJobs;
            }
            const minChildrenAgeField = this.$store.getters.minChildrenAgeField;
            if (
                minChildrenAgeField &&
                user[minChildrenAgeField]
            ) {
                // Filter out jobs which has children age < min children age
                let minAge = user[minChildrenAgeField];
                if (Array.isArray(minAge)) {
                    minAge = Math.min(
                        ...minAge.map((age) => this.getNumberFromString(age))
                    );
                } else {
                    minAge = this.getNumberFromString(minAge);
                }
                if (minAge) {
                    listJobs = listJobs.filter(
                        (job) => {
                            if (
                                !job.children_birthdays ||
                                !job.children_birthdays.length
                            ) {
                                return true;
                            }
                            return job.children_birthdays.every(
                                (birthday) =>
                                    !birthday || this.getAgeInYears(birthday) >= minAge
                            );
                        }
                    );
                }
            }
            return listJobs;
        },
        getAFillerIdOfJob(job) {
            if (job.selected_filler_id) {
                return job.selected_filler_id;
            }
            if (this.$store.getters.multipleFillersShiftJob) {
                if (Array.isArray(job.fillers)) {
                    if (!job.fillers || !job.fillers.length) {
                        return null;
                    }
                    const filler = job.fillers[0];
                    if (typeof filler === 'object') {
                        return filler.id;
                    }
                    return filler;
                } else {
                    return job.fillers;
                }
            } else {
                return job.filler;
            }
        },
        getObjectToCalculatePrice(user, job, expression, selectedDate) {
            const object = { ...user };
            if (job) {
                for (const key of Object.keys(job)) {
                    if (['filler', 'selected_filler_id', 'tentatively_filler'].includes(key) && job[key] && !isNaN(job[key])) {
                        object['candidate_rate'] = this.getCandidateRateById(job[key]);
                    }
                    let bookingVal = job[key];
                    if (['start_time', 'end_time'].includes(key)) {
                        if (bookingVal) {
                            bookingVal = this.getTimeString(bookingVal);
                        } else {
                            bookingVal = '';
                        }
                    }
                    object["booking_" + key] = bookingVal;
                    if (key === 'pet_ids') {
                        let numberOfPets = 0;
                        if (bookingVal && Array.isArray(bookingVal)) {
                            numberOfPets = bookingVal.length;
                        }
                        object["booking_number_pets"] = numberOfPets;
                    }
                }
            }
            if (job.index != null && job.index !== -1) {
                object['number_booking'] = job.index + 1;
            } else {
                object['number_booking'] = -1;
            }
            let number_fillers_need = job.number_fillers_need;
            if (number_fillers_need && !isNaN(number_fillers_need)) {
                object['number_fillers_need'] = Number(number_fillers_need);
            } else {
                object['number_fillers_need'] = 1;
            }

            // Check children_ages tag
            if (this.hasTagInExpression(expression, 'children_ages') && user) {
                let listChildren = user.children || [];
                const childrenAges = listChildren.filter(child => child.birthday).map(child => this.getAgeInYears(child.birthday));
                object['children_ages'] = childrenAges.join(',');
            }
            object['booking_number_days'] = 1;
            // Replace day of week
            const startDate = this.dateInDjangoFormat(job.date || selectedDate);
            if (startDate) {
                object['booking_date'] = startDate;
                const dayOfWeek = this.dateDayOfTheWeek(this.addCurrentTimeToDate(startDate), true);
                object['booking_week_day'] = dayOfWeek;
                const hoursBooked = this.calculateDuration(startDate, this.getTimeString(job.start_time), job.end_date, this.getTimeString(job.end_time), null, false) || 0;
                object['hours_booked'] = hoursBooked;
                object['booking_number_days'] = Math.ceil(hoursBooked / 24);
            }

            // Replace is_holiday
            let isHoliday = false;
            const listHolidays = this.$store.getters.agencyHolidayDates;
            if (listHolidays && listHolidays.length) {
                if (listHolidays.includes(this.getDayMonthFromDate(startDate))) {
                    isHoliday = true;
                }
            }
            object['on_holiday'] = isHoliday;
            // Replace hours_from_now
            object['hours_from_now'] = this.calculateHoursFromNow(startDate, job ? job.start_time : null);
            const outsideResult = this.isJobCreatedInBusinessHour(job);
            // Replace outside_business_hours
            object['outside_business_hours'] = !(outsideResult && outsideResult.isInside);
            // Replace is overnight booking
            object['overnight_booking'] = false;

            if (job.start_time && job.end_time) {
                const startTime = this.getTimeString(job.start_time);
                const endTime = this.getTimeString(job.end_time);
                if (startTime && endTime) {
                    if (startTime > endTime) {
                        object['overnight_booking'] = true;
                    }
                }
            }
            object['end_time_hours'] = 0;
            if (job.end_time) {
                const endTime = this.getTimeString(job.end_time);
                object['end_time_hours'] = this.convertTimeToInHours(endTime) || 0;
            }
            if (job.end_date) {
                const endDate = this.dateInDjangoFormat(job.end_date);
                if (endDate > startDate) {
                    object['overnight_booking'] = true;
                }
            }
            // Check filler_hours_worked_in_week tag
            if (this.hasTagInExpression(expression, 'filler_hours_worked_in_week')) {
                const mapHoursWorkedOfWeek = this.$store.getters.mapHoursWorkedOfWeek;
                if (mapHoursWorkedOfWeek && mapHoursWorkedOfWeek[job.id]) {
                    object['filler_hours_worked_in_week'] = mapHoursWorkedOfWeek[job.id];
                } else {
                    object['filler_hours_worked_in_week'] = 0;
                }
            }
            // Check filler_number_job_in_month tag
            object['filler_number_job_in_month'] = 1;
            if (this.hasTagInExpression(expression, 'filler_number_job_in_month')) {
                const fillerId = this.getAFillerIdOfJob(job);
                const mapJobNumberOfMonth = this.$store.getters.mapJobNumberOfMonth;
                if (mapJobNumberOfMonth && mapJobNumberOfMonth.fillerId == fillerId && mapJobNumberOfMonth.jobId == job.id
                    && mapJobNumberOfMonth.date == startDate) {
                    object['filler_number_job_in_month'] = mapJobNumberOfMonth.number || 1;
                } else {
                    object['filler_number_job_in_month'] = 1;
                }
            }
            // Check poster_number_job_in_month tag
            if (this.hasTagInExpression(expression, 'poster_number_job_in_month')) {
                const mapJobNumber = this.$store.getters.mapPosterJobNumber;
                let val = mapJobNumber[`${job.poster_id || job.poster}_${startDate}_${job.id || ''}_month`];
                if (val) {
                    if (!job.id) {
                        val = val + 1;
                    }
                    object['poster_number_job_in_month'] = val;
                } else {
                    object['poster_number_job_in_month'] = 1;
                }
            }
            // Check poster_number_job_in_week tag
            if (this.hasTagInExpression(expression, 'poster_number_job_in_week')) {
                const mapJobNumber = this.$store.getters.mapPosterJobNumber;
                let val = mapJobNumber[`${job.poster_id || job.poster}_${startDate}_${job.id || ''}_week`]
                if (val) {
                    if (!job.id) {
                        val = val + 1;
                    }
                    object['poster_number_job_in_week'] = val;
                } else {
                    object['poster_number_job_in_week'] = 1;
                }
            }
            // Check candidate_rate
            if (this.hasTagInExpression(expression, 'candidate_rate')) {
                const fillerId = this.getAFillerIdOfJob(job);
                if (fillerId) {
                    object['candidate_rate'] = this.getCandidateRateById(fillerId);
                }
            }
            return object;
        },
        hasTagInExpression(expression, tag) {
            if (!expression) {
                return false;
            }
            // Price expression
            if (expression.includes(`[[${tag}]]`)) {
                return true;
            }
            // Price condition
            if (expression.includes(`"model":"${tag}"`)) {
                return true;
            }
            return false;
        },
        getCandidateRateById(fillerId) {
            let candidateRate = 0;
            if (fillerId) {
                let candidate;
                if (this.$store.getters.selectedCandidate && this.$store.getters.selectedCandidate.id == fillerId) {
                    candidate = this.$store.getters.selectedCandidate;
                }
                if (!candidate) {
                    const candidateList = this.$store.getters.candidateListMainInfo || [];
                    candidate = candidateList.find(cand => cand.id === fillerId);
                }

                if (candidate && candidate.rate && !isNaN(candidate.rate)) {
                    candidateRate = Number(candidate.rate)
                }
            }
            return candidateRate;
        },
        getPriceFromExpression(user, job, expression, selectedDate) {
            const object = this.getObjectToCalculatePrice(user, job, expression, selectedDate);
            try {
                const price = this.calcEval(
                    "(function() {" +
                    this.replaceTagValue(
                        expression,
                        object,
                        false, [],
                        true
                    ) +
                    "}())"
                );
                return this.roundNumberTwoDigits(price);
            } catch (e) {
                console.log(e);
                return null;
            }
        },
        getJobLocations(poster, job) {
            let listLocations = [];
            if (job.locations && job.locations.length) {
                listLocations = job.locations;
            } else if (job.poster__locations && job.poster__locations.length) {
                listLocations = job.poster__locations;
            } else {
                if (poster && poster.locations) {
                    listLocations = poster.locations;
                }
            }
            return listLocations;
        },
        getTitleAvailableJobBoardCalendar(job) {
            const shiftJobCalendarClientNameModel = this.$store.getters.shiftJobCalendarClientNameModel;
            let posterName;
            if (shiftJobCalendarClientNameModel === "name") {
                posterName = `${job.poster__first_name} ${job.poster__last_name}`;
            } else {
                posterName = job["poster__" + shiftJobCalendarClientNameModel];
            }
            const mapTagValue = { ...job };
            mapTagValue.poster_name = posterName;
            const mapConvertKeys = {
                poster_first_name: 'poster__first_name',
                poster_last_name: 'poster__last_name',
                poster_employer_name: 'poster__employer_name'
            }
            for (const key of Object.keys(mapConvertKeys)) {
                mapTagValue[key] = mapTagValue[mapConvertKeys[key]]
            }
            const addresses = [];
            if (job.address1) {
                addresses.push(job.address1);
            }
            if (job.address2) {
                addresses.push(job.address2);
            }
            let address = addresses.join(' - ');
            if (address) {
                address = `- ${address}`;
            }
            mapTagValue.address = address;

            if (job.start_time && job.end_time) {
                mapTagValue.start_time = this.djangotimeformatAMPM(job.start_time);
                mapTagValue.end_time = this.djangotimeformatAMPM(job.end_time);
            }

            let bookingTitle = this.replaceTagValue(
                this.$store.getters.shiftJobCalendarTitleAvailableJobBoard,
                mapTagValue
            );
            const mapReplaceValues = { "{}": "", "( - )": "", " - )": ")" };
            for (const replaceKey of Object.keys(mapReplaceValues)) {
                bookingTitle = bookingTitle.replace(
                    replaceKey,
                    mapReplaceValues[replaceKey]
                );
            }
            return bookingTitle;
        },
        getMapJobTags(job, poster) {
            // Get replaced value for broadcast new shift job
            return new Promise(async (resolve) => {
                const mapReplacedValues = {};
                if (poster) {
                    const listChildren = await this.getListChildren(poster);
                    const children = await this.getProfileSectionContent(poster,
                        listChildren, MAP_DIALOG_SECTION.Children.name, true);
                    mapReplacedValues['children'] = children;
                    let childrenText = this.getHtmlText(children, true).trim();
                    const mapReplaced = {
                        '\n\n\n\n\n\n\n\n\n': '\n',
                        '\n\n\n\n\n\n\n\n': '\n',
                        '\n\n\n\n\n\n\n': '\n',
                        '\n\n\n\n\n\n': '\n',
                        '\n\n\n': ': '
                    }
                    childrenText = this.replaceAllByMap(childrenText, mapReplaced);
                    mapReplacedValues['children_text'] = childrenText;
                    const childrenAges = listChildren.map(child => this.getAge(child.birthday)).join('; ');
                    mapReplacedValues['ages_of_children'] = childrenAges;
                    const compressedChildrenAges = listChildren.map(child => this.getCompressedAge(child.birthday)).join('; ');
                    mapReplacedValues['ages_of_children_compressed'] = compressedChildrenAges;

                    const pets = await this.getListPets(poster);
                    mapReplacedValues['pets'] = this.getProfileSectionContent(poster, pets, MAP_DIALOG_SECTION.Pet.name);
                }
                resolve(mapReplacedValues);
                return;
            });
        },
        getJobTitle(job) {
            let jobTitle = "";
            if (job.date) {
                jobTitle += ` on ${this.getDateString(job.date)}`;
                if (job.start_time && job.end_time) {
                    jobTitle += ` ${this.djangotimeformatAMPM(
                        job.start_time
                    )}-${this.djangotimeformatAMPM(job.end_time)}`;
                }
            }
            return jobTitle;
        },
        getCategoryList(bookingField) {
            if (!bookingField || !bookingField.categoryList) {
                return [];
            }
            return this.normalizedArrayValue(bookingField.categoryList)
        },
        setMapJobNumberOfMonthOnAssignJob(job, startDate, fillerId) {
            return new Promise(async (resolve) => {
                let jobNumber = 1;
                const date = this.dateInDjangoFormat(startDate);
                if (fillerId) {
                    let url = `/get-job-number-of-month/?filler=${fillerId}&date=${date}`;
                    if (job.id) {
                        url = `${url}&job=${job.id}`;
                    }
                    const res = await axios.get(url);
                    jobNumber = res.data.number;
                }

                this.$store.dispatch('setMapJobNumberOfMonth', {
                    number: jobNumber,
                    fillerId: fillerId,
                    jobId: job.id,
                    date: date,
                    time: this.getTimeString(job.start_time),
                });
                resolve();
            });
        },
        getJobsDatesTimes(listJobs) {
            if (!listJobs) {
                return "";
            }
            return listJobs
                .map((job) => {
                    if (!job.date) {
                        return "";
                    }
                    let startTime = job.start_time;
                    if (typeof startTime === 'object') {
                        startTime = this.getTimeString(job.start_time);
                    }
                    let endTime = job.end_time;
                    if (typeof endTime === 'object') {
                        endTime = this.getTimeString(job.end_time);
                    }
                    return `${this.getDateString(job.date)}: ${this.djangotimeformatAMPM(startTime)} - ${this.djangotimeformatAMPM(endTime)}`
                })
                .join("<br/>");
        },
        getJobsDatesTimesCompressed(listJobs) {
            if (!listJobs) {
                return "";
            }
            return listJobs
                .map((job) => {
                    if (!job.date) {
                        return "";
                    }
                    let startTime = job.start_time;
                    if (typeof startTime === 'object') {
                        startTime = this.getTimeString(job.start_time);
                    }
                    let endTime = job.end_time;
                    if (typeof endTime === 'object') {
                        endTime = this.getTimeString(job.end_time);
                    }
                    return `${this.compressDateFormat(job.date)}: ${this.compressTimeFormat(startTime)} - ${this.compressTimeFormat(endTime)}`
                })
                .join("\n");
        },
        formatDisplayJobField(job, field) {
            const model = field.model;
            const data = job[field.model];
            if (Array.isArray(data) && !data.length) {
                return "";
            }
            if (Array.isArray(data) && data.length) {
                return data.join(", ");
            }
            if (model === "location") {
                const locationInfo = [];
                const listLocationModels = ["city", "provincestate", "postal_code"];
                for (const locationModel of listLocationModels) {
                    if (job[locationModel]) {
                        locationInfo.push(job[locationModel]);
                    }
                }
                if (locationInfo.length == 3) {
                    // if job has city, state and postal code, join by comma and space
                    const last = locationInfo.pop();
                    return locationInfo.join(", ") + " " + last;
                }
                return locationInfo.join(", ");
            }
            if (
                [
                    "date",
                    "end_date",
                    "created_date",
                    "last_updated_date",
                    "last_activity",
                    "actual_start_date",
                    "actual_end_date",
                    "filled_date",
                ].includes(model)
            ) {
                return data ? new Date(data).toDateString() : "";
            }
            return data;
        },
        isRefundCreditByFilledStatus(job) {
            if (this.$store.getters.onlyRefundForFilledJob) {
                if (job.filled) {
                    return true;
                }
            } else if (this.$store.getters.onlyRefundForNonFilledJob) {
                if (!job.filled) {
                    return true;
                }
            } else {
                return true;
            }
            return false;
        },
    }
});


// WEBPACK FOOTER //
// ./src/mixins/job-handling.js